// Helper function to safely check environment
export const isDevEnvironment = () => {
  try {
    return process.env.NODE_ENV === 'development' ||
      process.env.REACT_APP_NODE_ENV === 'development';
  } catch (e) {
    return false;
  }
}

// Helper function to check if the environment is production
export const isProdEnvironment = () => {
  try {
    return !(process.env.REACT_APP_BASE_URL.includes("stage") ||
      process.env.REACT_APP_DIGMS_API_BASE_URL.includes("stage") || process.env.REACT_APP_BASE_URL.includes("localhost") || process.env.NODE_ENV === 'development');
  } catch (e) {
    return false;
  }
}

// Client Data Platform parameters
let apiSubdomain = `https://api.`;
if(!isProdEnvironment())
  apiSubdomain = `https://stage-api.`;

export const COGNITO_USER_POOL_CLIENT_ID = "2fs2geiekfaonh5thfhsfvstdm";

export const DIGMS_API_BASE_URL = process.env.REACT_APP_DIGMS_API_BASE_URL; // Set in Jenkinsfile or .env
export const DS_BASE_URL = apiSubdomain + DIGMS_API_BASE_URL; 
export const CLIENTS_ENDPOINT = '/clients'; // PROD
export const UPDATE_A_CLIENT_ENDPOINT = "/clients"; // PROD
export const GET_ALL_PACKAGES_ENDPOINT = "/clients/packages"; // PROD
export const GET_ALL_VERTICALS_ENDPOINT = "/clients/verticals"; // PROD
export const GET_ALL_PLATFORMS_ENDPOINT = "/clients/platforms"
export const ACCOUNT_DETAILS_ENDPOINT = "/clients/account-details";
export const ADD_TO_HISTORICAL_PULL_QUEUE_ENDPOINT = "/clients/historical-pull/schedule";
export const GET_HISTORICAL_PULL_QUEUE_ENDPOINT = "/clients/historical-pull/queued-clients";

// Authentication
export const APP_BASE_URL = process.env.REACT_APP_BASE_URL // Set in Jenkinsfile or .env
export const APP_BASE_URL_DEV = "http://localhost:3000"; // DEV

//Marketing IDs endpoints
export const MARKETING_IDS_BASE_URL = process.env.REACT_APP_MARKETING_IDS_BASE_URL;
export const MARKETING_IDS_MIGRATION_URL = process.env.REACT_APP_MARKETING_IDS_MIGRATION_URL;
export const MARKETING_IDS_READ_ENDPOINT = "/read";
export const MARKETING_IDS_CREATE_ENDPOINT = "/write";
export const MARKETING_IDS_DELETE_ENDPOINT = "/delete";